<template>
  <div class="main-nav">

    <!-- <a 
      :href="`/`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      <i class="fas fa-home small"></i>
      {{lg('',{
        en: 'Home',
        zh: '',
      })}}
    </a> -->

    <a 
      :href="`https://jgndefi.com/`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      <i class="fas fa-home small"></i>
      {{lg('',{
        en: 'HOME',
        zh: '首页',
      })}}
    </a>

    <a 
      :href="`https://jgnnft.com/`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      <i class="fas fa-shopping-cart small"></i>
      {{lg('',{
        en: 'NFT MARKETPLACE',
        zh: '',
      })}}
    </a>

    <!-- <router-link
      :to="'/ilava'"
      class="d-block ml-4"
      @click.native="hideMainnav()"
      >
      {{lg('',{
        en: 'iLAVA',
        zh: '',
      })}}
    </router-link> -->

    <!-- <a 
      :href="`https://exchange.lavaswap.com`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      {{lg('',{
        en: 'Swap',
        zh: '交易',
      })}}
    </a> -->

    <!-- <router-link
      :to="{name:'pool_comingsoon'}"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      {{lg('',{
        en: 'Pool',
        zh: '流动性矿池',
      })}}
    </router-link> -->

    <!-- <router-link
      :to="{name:'pool'}"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      {{lg('',{
        en: 'Pool',
        zh: '流动性矿池',
      })}}
    </router-link> -->

    <!-- swap的 ComingSoon页 链接 -->
    <!-- <router-link
      :to="'/swap'"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      {{lg('',{
        en: 'Swap',
        zh: '交易',
      })}}
    </router-link> -->
    <!-- Swap的跳转链接 -->

    <!-- <router-link
      :to="'/'"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      <i class="fas fa-tractor small"></i>
      {{lg('',{
        en: 'Farm',
        zh: '质押挖矿池',
      })}}
    </router-link> -->

    <!-- <a 
      :href="`https://info.lavaswap.com`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      {{lg('',{
        en: 'Info',
        zh: '行情',
      })}}
    </a> -->


    <!-- <a 
      :href="`https://bridge.lavaswap.com`" 
      target="_blank" 
      class="d-block ml-4" 
      @click="hideMainnav()">
      {{lg('',{
        en: 'Bridge',
        zh: '跨链桥',
      })}}
    </a> -->

    <!-- <a href="/" target="_blank" class="d-block ml-4">
      Swap
    </a> -->

    <!-- <router-link
      :to="'/bridge'"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      {{lg('',{
        en: 'Bridge',
        zh: '跨链桥',
      })}}
    </router-link> -->

    <!-- <router-link
      :to="'/playpage'"
      class="d-block ml-4"
      @click.native="hideMainnav()"
    >
      Playpage
    </router-link> -->

  </div>
</template>

<script>
import bus from '@/bus.js'

export default {
  name: 'mainnav',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    hideMainnav(){
      console.log(bus.topnavvue)
      bus.topnavvue.dropnavOpen = false
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .main-nav{
    @media(max-width: 788px){
      a{
        margin-top: 25px;
      }
    }
  }
</style>